import type { ActivePromotionDTO } from "@biosany/shared"

/** Vista legacy compatible con el checkout. */
export interface PromotionView {
	/** Entero 0-100 — única fuente para el cálculo de dinero (ver applyPercentDiscount). */
	discountPercent: number
	/** @deprecated Fracción derivada de discountPercent; solo para checks de "hay descuento". */
	discount: number
	isEnabled: boolean
	offer: number
	percentage: string
	message: string
	validUntil: string | null
	freeShipping: boolean
	itemIds: string[]
	id: string | null
}

export function toPromotionView(active: ActivePromotionDTO | null): PromotionView {
	if (!active) {
		return {
			discountPercent: 0,
			discount: 0,
			isEnabled: false,
			offer: 1,
			percentage: "",
			message: "",
			validUntil: null,
			freeShipping: false,
			itemIds: [],
			id: null
		}
	}

	const discount = active.discountPercent / 100
	return {
		discountPercent: active.discountPercent,
		discount,
		isEnabled: true,
		offer: 1 - discount,
		percentage: active.discountPercent > 0 ? `${active.discountPercent}%` : "",
		message: active.message,
		validUntil: new Date(active.endDate).toLocaleDateString("es-MX"),
		freeShipping: active.freeShipping,
		itemIds: active.itemIds,
		id: active.id
	}
}

/** @deprecated Prefer useActivePromotion + toPromotionView. Kept for non-React modules. */
export const PROMO: PromotionView = toPromotionView(null)
